/**
 * DocumentSetEventEntityHierarchy
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EventEntityHierarchy from '../../../../components/EventEntityHierarchy';

// Selectors
import { makeSelectDocumentSetValue } from '../../../../services/documentSets/selectors';

interface Props {
    eventId?: number;
}

export class DocumentSetEventEntityHierarchy extends React.PureComponent<Props> {
    render() {
        const { eventId } = this.props;
        if (!eventId) return null;
        return <EventEntityHierarchy eventId={eventId} />;
    }
}

const mapStateToProps = createStructuredSelector({
    eventId: makeSelectDocumentSetValue('eventId')
});

export default connect(mapStateToProps)(DocumentSetEventEntityHierarchy);
